import React from 'react'
import { useSelector } from 'react-redux'
import history from 'browserHistory'

import RoutesHelper from 'helpers/RoutesHelper'
import { selectors as UISelectors } from 'data/ui'
import { COMMENTS, OUTLINE } from 'data/ui/UrlPanelTypes'

export function withNoteMetaPanelControls(Component) {
  return function WrapWithNoteMetaPanelControls(props) {
    const channelId = useSelector(UISelectors.getActiveChannelId)
    const filterId = useSelector(UISelectors.getActiveFilterId)
    const noteId = useSelector(UISelectors.getActiveNoteId)
    const isCommentPanelOpened = useSelector(UISelectors.isCommentsOpen)
    const isOutlinePanelOpened = useSelector(UISelectors.isOutlineOpen)

    const navigateWithOptions = React.useCallback(
      (options, { threadId = null, mainPanel = false } = {}) => {
        const params = {
          noteId,
          channelId,
          filterId,
          // from: router.location.query.from, TODO?
          threadId,
          options,
        }
        if (channelId) {
          history.push(RoutesHelper.noteChannelShow({ ...params }))
        } else if (filterId) {
          history.push(RoutesHelper.noteFilterShow({ ...params }))
        } else {
          history.push(RoutesHelper.noteShow({ ...params }))
        }
      },
      [channelId, filterId, noteId]
    )

    const hideNoteMetaPanel = React.useCallback(
      () => {
        navigateWithOptions()
      },
      [navigateWithOptions]
    )

    const showComments = React.useCallback(
      ({ threadId, mainPanel } = {}) => {
        navigateWithOptions(COMMENTS, { threadId, mainPanel })
      },
      [navigateWithOptions]
    )

    const hideComments = React.useCallback(
      () => {
        hideNoteMetaPanel()
      },
      [hideNoteMetaPanel]
    )

    const showOutline = React.useCallback(
      () => {
        navigateWithOptions(OUTLINE)
      },
      [navigateWithOptions]
    )

    const hideOutline = React.useCallback(
      () => {
        hideNoteMetaPanel()
      },
      [hideNoteMetaPanel]
    )

    const toggleOutline = React.useCallback(
      () => {
        if (isOutlinePanelOpened) {
          hideOutline()
        } else {
          showOutline()
        }
      },
      [hideOutline, showOutline, isOutlinePanelOpened]
    )

    const toggleComments = React.useCallback(
      ({ threadId = null, mainPanel = false } = {}) => {
        let options = COMMENTS
        if (isCommentPanelOpened && !threadId && !mainPanel) {
          options = null
        }
        navigateWithOptions(options, { threadId, mainPanel })
      },
      [navigateWithOptions, isCommentPanelOpened]
    )

    return (
      <Component
        hideNoteMetaPanel={hideNoteMetaPanel}
        // Comments
        showComments={showComments}
        hideComments={hideComments}
        toggleComments={toggleComments}
        // Outline
        showOutline={showOutline}
        hideOutline={hideOutline}
        toggleOutline={toggleOutline}
        {...props}
      />
    )
  }
}
